module.exports = __webpack_public_path__ + "static/media/about-shap-mobile.7bbaf9e3.svg";